'use client'

import CartItem from './cart-item'
import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import useShoppingCart from '@dustin-web/microsite-data/src/hooks/use-shopping-cart-internal'
import { useSpoofedUi } from '../../dev/cartsite-dev-admin'

const CartItemList = () => {
  const { showPricesInclVat } = useUserSettings()
  const { updateCart, cartItems } = useShoppingCart({
    withRequiredEndUserInformation: true,
  })

  const mainItems = cartItems.filter(i => !i.mainProductErpIdentifier)

  const spoofedUi = useSpoofedUi()
  spoofedUi?.alterCartItems(cartItems)

  return (
    <ul className="ul-stripped">
      {mainItems.map(
        (item, i) =>
          item && (
            <CartItem
              key={item.id}
              digitalDataOrigin="shoppingCart"
              digitalDataOriginChild="shoppingCartAccessories"
              digitalDataIndex={cartItems.indexOf(item)}
              item={item}
              childItems={cartItems.filter(i => i.parentCartItemId === item.id)}
              updateCart={updateCart}
              showPriceIncVat={showPricesInclVat}
              isFirstItem={i === 0}
            />
          )
      )}
    </ul>
  )
}

export default CartItemList
